module.exports = __webpack_public_path__ + "static/media/00.b5e1fa1a.jpg";